import React from 'react';
import { MessageCircle } from 'lucide-react';
import { instituteMock } from '../data/mock';

const WhatsAppButton = () => {
  const { contact } = instituteMock;

  const handleClick = () => {
    const phone = contact.whatsapp.replace(/\D/g, '');
    window.open(`https://wa.me/55${phone}`, '_blank');
  };

  return (
    <button 
      className="whatsapp-float-button"
      onClick={handleClick}
      aria-label="Falar no WhatsApp"
    >
      <MessageCircle size={28} />
    </button>
  );
};

export default WhatsAppButton;
